export const TOOLBAR_HEIGHT = 64;
export const TOOLBAR_HEIGHT_XS = 56;
export const TOOLBAR_HEIGHT_PICKER = 52;
export const THEME_SPACING = 8;
